export default "__VITE_ASSET__8$kGsrHy__"